import React, { useEffect, useMemo, useState, useRef } from "react";
// import "./largeAccount.css";

import {
  DeleteDND,
  downloadSubscriberRevenueReport,
  fetchReport,
  findDNDList,
  GetContentProviderData,
  GetContentProviderDataNew,
  GetCountries,
  getCountryCodeList,
  GetServicePackageData,
  GetServicesData,
} from "../../../api/Api";
import Swal from "sweetalert2";
import { Navigate } from "react-router-dom";
import CustomTable from "../../../components/Table/CustomTable";
import Loader from "../../../components/loader/loader";
import { getFromLocalStorage } from "../../../utils/common-utils";
import PaginationComponent from "../../../components/Pagination/PaginationComponent";
import "./manageReport.css";

// Add the download function

const SubscriberRevenueReport = () => {
  const [loaders, setLoaders] = useState({
    countryLoader: false,
  });
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [dndList, setDndList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  console.log("currentPage", currentPage);
  const [pageSize, setPageSize] = useState(10);
  const [cpList, setCpList] = useState([]);
  const [viewDndModal, setViewDndModal] = useState(false);
  const [contentPartner, setContentPartner] = useState("");
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [countryListData, setCountryListData] = useState([]);
  const [serviceListData, setServiceListData] = useState([]);
  const [servicePackageListData, setServicePackageListData] = useState([]);
  const [tableConfig, setTableConfig] = useState({
    enabledColumns: [],
    actions: [],
  });

  console.log("contentPartnerrrrrrr", contentPartner);

  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [searchCountry, setSearchCountry] = useState("");
  const dropdownRef = useRef(null);
  const [paginationData, setPaginationData] = useState({
    totalElements: 0,
    totalPages: 0,
  });
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [dateRange, setDateRange] = useState({
    startDate: "",
    endDate: "",
  });
  const [isDataAvailable, setIsDataAvailable] = useState(false);

  const userData = getFromLocalStorage("userData");
  console.log("userDataress", userData);
  const getCountriesAndOperators = async () => {
    setLoaders((prev) => ({ ...prev, countryLoader: true }));
    try {
      const response = await GetCountries();
      if (response?.statusDescription?.status == 200) {
        setCountryList(
          userData?.userGroups == 6
            ? userData?.cpCountryList
            : response?.countryResponseList
        );
      } else if (response?.statusDescription?.status == 401) {
        handleUnauthorized();
      } else {
        setCountryList([]);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
      setCountryList([]);
    }
    setLoaders((prev) => ({ ...prev, countryLoader: false }));
  };

  useEffect(() => {
    getCountriesAndOperators();
  }, []);

  // Reset operator when country changes
  useEffect(() => {
    setSelectedOperator(null);
  }, [selectedCountry]);

  const handleCountryChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      // If "All" is selected, set all fields to "All"
      setSelectedCountry({ countryName: "All", cnUniId: "All" });
      setSelectedOperator({ operatorName: "All", opUniId: "All" });
      if (userData?.userGroups !== 4 && userData?.userGroups !== 6) {
        setContentPartner("All");
      }
      setSelectedService({ id: "All" });
      setSelectedPackage({ id: "All" });
      // Clear the lists since they're not needed when "All" is selected
      setServiceListData([]);
      setServicePackageListData([]);
    } else {
      const country = countryList.find((c) => c.countryName === value);
      setSelectedCountry(country);
      // Reset other fields
      setSelectedOperator(null);
      if (userData?.userGroups !== 4 && userData?.userGroups !== 6) {
        setContentPartner("");
      }
      setSelectedService(null);
      setSelectedPackage(null);
    }
  };
  console.log("contentPartner", userData?.userGroups);
  const handleOperatorChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setSelectedOperator({ operatorName: "All", opUniId: "All" });
      if (userData?.userGroups !== 4 && userData?.userGroups !== 6) {
        setContentPartner("All");
      }
      setSelectedService({ id: "All" });
      setSelectedPackage({ id: "All" });
      // Clear the service and package lists since they're not needed when "All" is selected
      setServiceListData([]);
      setServicePackageListData([]);
    } else {
      let operator;
      if (userData?.userGroups == 6) {
        operator = selectedCountry?.cpOperatorList?.find(
          (op) => op?.operatorName === value
        );
      } else {
        operator = selectedCountry?.operatorList?.find(
          (op) => op?.operatorName === value
        );
      }
      setSelectedOperator(operator);
      if (userData?.userGroups !== 4 && userData?.userGroups !== 6) {
        setContentPartner("");
      }
      setSelectedService(null);
      setSelectedPackage(null);
    }
  };

  const handleContentPartnerChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setContentPartner("All");
      setSelectedService({ id: "All" });
      setSelectedPackage({ id: "All" });
      setServiceListData([]);
      setServicePackageListData([]);
    } else {
      setContentPartner(value);
      setSelectedService(null);
      setSelectedPackage(null);
      getAllData();
    }
    localStorage.setItem("selectedContentPartnerId", value);
  };

  const handleServiceChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setSelectedService({ id: "All" });
      setSelectedPackage({ id: "All" });
    } else {
      const service = serviceListData.find(
        (service) => service.id === parseInt(value)
      );
      setSelectedService(service);
      setSelectedPackage(null);
      console.log("serviceeeee", service);
      if (service) {
        getServicePackageDataapi(service);
      }
    }
  };

  const handlePackageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setSelectedPackage({ id: "All" });
    } else {
      const packageId = parseInt(value);
      const selectedPkg = servicePackageListData.find(
        (pkg) => pkg.id === packageId
      );
      setSelectedPackage(selectedPkg);
    }
  };

  // Add this helper function to calculate the actual input length needed
  const getRequiredLength = () => {
    if (!selectedCountry?.msisdnLength || !selectedCountry?.msisdnPrefix)
      return 0;
    return selectedCountry.msisdnLength - selectedCountry.msisdnPrefix.length;
  };

  const handleUnauthorized = () => {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Unauthorized access",
    });
    Navigate("/");
  };

  const getCpList = async () => {
    setLoaders((prev) => ({ ...prev, cpLoader: true }));
    let payload = {
      pageNo: 0,
      pageSize: 1000,
      userId: getFromLocalStorage("userData")?.id,
      status: 1,
      countryId:
        selectedCountry?.cnUniId === "All" ? "All" : selectedCountry?.cnUniId,
      operatorId:
        selectedOperator?.opUniId === "All" ? "All" : selectedOperator?.opUniId,
    };
    const response = await GetContentProviderDataNew(payload);
    console.log("resFetchBUvvv", response);
    setLoaders((prev) => ({ ...prev, cpLoader: false }));
    if (response?.statusDescription?.status == 200) {
      setCpList(response?.userListPage?.content);
    } else if (response?.statusDescription?.status == 401) {
      handleUnauthorized();
    } else {
      setCpList([]);
    }
  };

  useEffect(() => {
    getCpList();
  }, [selectedCountry, selectedOperator]);

  useEffect(() => {
    // If userGroups is 4, set the content partner to the user's ID
    if (userData?.userGroups === 4) {
      setContentPartner(
        userData?.userGroups === 4 ? userData?.id.toString() : ""
      );
    }
  }, [userData]);

  const getAllData = async () => {
    // setStateData((prev) => ({ ...prev, tableLoader: true }));
    let payload = {
      pageNo: currentPage,
      pageSize: pageSize,
      userId:
        getFromLocalStorage("userData")?.userGroups == 6
          ? Number(contentPartner)
          : getFromLocalStorage("userData")?.id,
      status: 1,
      cpId: Number(contentPartner),
      countryCode: selectedCountry?.countryId || "",
      operatorCode: selectedOperator?.operatorId || "",
    };
    const response = await GetServicesData(payload);
    console.log("resFetchBUss", response);
    // setStateData((prev) => ({ ...prev, tableLoader: false }));
    if (response?.statusDescription?.status == 200) {
      const contentWithActions = response?.cpServiceList?.content?.map(
        (item) => ({
          ...item,
          actions: response?.action,
        })
      );
      setServiceListData(contentWithActions);
      console.log("contentWithActions", contentWithActions);
    } else if (response?.statusDescription?.status == 401) {
      handleUnauthorized();
    } else {
    }
  };

  console.log("gggggggggggg", contentPartner);
  useEffect(() => {
    if (contentPartner) {
      getAllData();
    }
  }, [currentPage, pageSize, contentPartner]);

  const getServicePackageDataapi = async (selectedService) => {
    let payload = {
      pageNo: currentPage,
      pageSize: pageSize,
      // userId: getFromLocalStorage("userData")?.id,
      userId:
        getFromLocalStorage("userData")?.userGroups == 6
          ? Number(contentPartner)
          : getFromLocalStorage("userData")?.id,
      serviceId: selectedService?.id,
      cpId: selectedService?.cpId,
      status: 1,
    };

    try {
      const response = await GetServicePackageData(payload);
      console.log("responsetbb", response);

      if (response?.statusDescription?.status === 200) {
        const contentServicePackage = response?.serviceModel?.content?.map(
          (item) => ({
            ...item,
            actions: response?.action,
          })
        );
        setServicePackageListData(contentServicePackage);
      }
    } catch (error) {
      console.error("Error fetching service package data:", error);
    }
  };

  useEffect(() => {
    getServicePackageDataapi();
  }, []);

  console.log("cpList", cpList);
  console.log("servicePackageListData", servicePackageListData);
  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }

    if (selectedCountry?.countryName === "All") {
      // When country is "All", only validate date range
      if (!dateRange.startDate || !dateRange.endDate) {
        // Swal.fire({
        //   icon: "error",
        //   title: "Error",
        //   text: "Please select both start and end dates",
        // });
        return;
      }
    }
    else {
      // Normal validation when specific country is selected
      if (
        !selectedCountry ||
        !selectedOperator ||
        !contentPartner ||
        !selectedService ||
        !selectedPackage ||
        !dateRange.startDate ||
        !dateRange.endDate
      ) {
        // Swal.fire({
        //   icon: "error",
        //   title: "Error",
        //   text: "Please fill all required fields",
        // });
        return;
      }
    }

    try {
      const payload = {
        userId:
          getFromLocalStorage("userData")?.userGroups === 6
            ? contentPartner?.toString()
            : getFromLocalStorage("userData")?.id,
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
        countryCode:
          selectedCountry?.countryName === "All"
            ? "All"
            : userData?.userGroups == 6
            ? selectedCountry?.countryId
            : selectedCountry?.cnUniId,
        operatorCode:
          selectedOperator?.operatorName === "All"
            ? "All"
            : userData?.userGroups == 6
            ? selectedOperator?.operatorId
            : selectedOperator?.opUniId,
        cpList:
          userData?.userGroups === 4
            ? userData?.id?.toString()
            : // : userData?.userGroups === 6
            // ? userData?.userId?.toString()
            contentPartner === "All"
            ? "All"
            : contentPartner?.toString(),
        serviceList:
          selectedService?.id === "All"
            ? "All"
            : selectedService?.id?.toString(),
        packageId:
          selectedPackage?.id === "All"
            ? "All"
            : selectedPackage?.id?.toString(),
        pageNo: currentPage,
        pageSize: pageSize,
      };

      console.log("payloadddd", payload);

      const response = await fetchReport(payload);
      if (response?.statusDescription?.status === 200) {
        if (
          !response.revenueList?.content?.length ||
          response.revenueList === null
        ) {
          setIsDataAvailable(false);
          Swal.fire({
            icon: "info",
            title: "No Data",
            text: "No data found for the selected criteria",
          });
          // Reset the table data
          setDndList([]);
          setTableConfig({
            enabledColumns: response.enabledColumns,
            actions: [],
          });
          setPaginationData({
            totalElements: 0,
            totalPages: 0,
          });
          return;
        }

        setIsDataAvailable(true);
        // If we have data, process it
        const revenueData = response.revenueList.content.map((item) => ({
          ...item,
          sno: currentPage * pageSize + 1,
        }));

        setDndList(revenueData);
        setTableConfig({
          enabledColumns: response.enabledColumns,
          actions: [],
        });
        setPaginationData({
          totalElements: response.revenueList.page.totalElements,
          totalPages: response.revenueList.page.totalPages,
        });
      } else if (
        response?.statusDescription?.status === 210 ||
        response?.statusDescription?.status === 201
      ) {
        Swal.fire({
          icon: "info",
          title: "No Data",
          text: response?.statusDescription?.description || "No data found",
        });
      } else if (response?.statusDescription?.status === 401) {
        handleUnauthorized();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            response?.statusDescription?.description ||
            "Failed to fetch report data",
        });
      }
    } catch (error) {
      setIsDataAvailable(false);
      console.error("Error submitting:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to submit request",
      });
    }
  };

  const handleTableAction = (action, rowData) => {
    switch (action.action) {
      case "View":
        setSelectedRowData(rowData);
        setViewDndModal(true);
        break;
      case "Delete":
        handleDelete(rowData);
        break;
      default:
        break;
    }
  };

  const handleDelete = (rowData) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Want to delete this number? It won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const payload = {
            userId: getFromLocalStorage("userData")?.id,
            id: rowData.id,
          };

          const response = await DeleteDND(payload);
          if (response?.statusDescription?.status === 200) {
            Swal.fire(
              "Deleted!",
              response.statusDescription.description || "DND has been deleted.",
              "success"
            );
            // Refresh the DND list
            setDndList([]);
            setSelectedCountry(null);
            setSelectedOperator(null);
            setPhoneNumber("");
            // handleSubmit(new Event("submit"));
          } else {
            throw new Error(
              response?.statusDescription?.description || "Delete failed"
            );
          }
        } catch (error) {
          console.error("Delete error:", error);
          Swal.fire("Error!", error.message || "Failed to delete DND", "error");
        }
      }
    });
  };

  // Add this useEffect for handling clicks outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowCountryDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Add this helper function to render action buttons
  const renderActionButtons = (actions) => {
    return actions.map((action) => (
      <button
        key={action.id}
        className={`btn btn-link ${action.colorCode}`}
        title={action.titleName}
        onClick={() => handleTableAction(action)}
      >
        <i className={action.iconName}></i>
      </button>
    ));
  };

  console.log("cccccc", dndList);

  // Add reset function at component level
  const handleReset = () => {
    setSelectedCountry(null);
    setSelectedOperator(null);
    setContentPartner("");
    setSelectedService(null);
    setSelectedPackage(null);
    setDateRange({
      startDate: "",
      endDate: "",
    });
    setDndList([]);
    setServiceListData([]);
    setServicePackageListData([]);
    setIsDataAvailable(false);
    setCurrentPage(0);
    setPageSize(10);
    setPaginationData({
      totalElements: 0,
      totalPages: 0,
    });
  };

  // Add download handler
  const handleDownload = async () => {
    try {
      setDownloadLoader(true);
      const payload = {
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
        countryCode:
          selectedCountry?.countryName === "All"
            ? "All"
            : userData?.userGroups == 6
            ? selectedCountry?.countryId
            : selectedCountry?.cnUniId,
        operatorCode:
          selectedOperator?.operatorName === "All"
            ? "All"
            : userData?.userGroups == 6
            ? selectedOperator?.operatorId
            : selectedOperator?.opUniId,
        cpList: contentPartner === "All" ? "All" : contentPartner,
        serviceList:
          selectedService?.id === "All"
            ? "All"
            : selectedService?.id?.toString(),
        packageId:
          selectedPackage?.id === "All"
            ? "All"
            : selectedPackage?.id?.toString(),
        pageNo: currentPage,
        pageSize: pageSize,
        type: "revenue",
      };

      const response = await downloadSubscriberRevenueReport(payload);
      console.log("responseeeeeeee", response);

      if (response?.statusDescription?.status == 200 && response?.fileName) {
        // Create a temporary link element
        const link = document.createElement("a");
        link.href = response.fileName; // Use the URL directly
        link.target = "_blank"; // Open in new tab
        link.download = response.fileName.split("/").pop(); // Extract filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to download report. Please try again.",
        });
      }
    } catch (error) {
      console.error("Download error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to download report. Please try again.",
      });
    } finally {
      setDownloadLoader(false);
    }
  };

  useEffect(() => {
    // if (selectedCountry?.countryName === "All") {
    //   if (
    //     !dateRange.startDate ||
    //     !dateRange.endDate
    //   ) {
    //     handleSubmit();
    //   }
    // } else {
    //   if (
    //     !selectedCountry ||
    //     !selectedOperator ||
    //     !contentPartner ||
    //     !selectedService ||
    //     !selectedPackage ||
    //     !dateRange.startDate ||
    //     !dateRange.endDate
    //   ) {
        handleSubmit();
    //   }
    // }
  }, [currentPage, pageSize]);

  return (
    <div className="content-wrapper">
      <section className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="box">
              <div className="box-header">
                <div className="row">
                  <div className="col-md-8 col-12">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb breadcrumb_bg">
                        <li className="breadcrumb-item">
                          <a className="breadcrumb_1">Manage Reports</a>
                        </li>
                        <li
                          className="breadcrumb-item active breadcrumb_2 d-flex align-items-center"
                          aria-current="page"
                        >
                          <span>Subscriber Revenue Report</span>
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <div className="col-md-4 col-12 mt_3 d-flex align-items-center justify-content-end">
                    {isDataAvailable && (
                      <div className="btn-group float-right">
                        <button
                          type="button"
                          className="btn btn-primary btn-raised btn-flat create_cp"
                          onClick={handleDownload}
                          disabled={downloadLoader}
                        >
                          {downloadLoader ? "Downloading..." : "Download"}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="box-body px-1 px-md-4 pt-0 mt-0 box_bdy_mob">
                <div className="card mt-2 p-3 position-relative">
                  <span className="mt-2 mb-3 fw-bold badge_head text-center">
                    Subscriber Revenue Report
                  </span>
                  <form onSubmit={handleSubmit}>
                    <div className="row pt-3">
                      <div className="form-group col-sm-3">
                        {/* <div className="form-group"> */}
                        <label>
                          Select Country<span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          value={selectedCountry?.countryName || ""}
                          onChange={handleCountryChange}
                          required
                        >
                          <option value="">Select Country</option>
                          {userData?.userGroups != 6 && (
                            <option value="All">All</option>
                          )}
                          {countryList.map((country) => (
                            <option
                              key={country.id}
                              value={country.countryName}
                            >
                              {country.countryName}
                            </option>
                          ))}
                        </select>
                        {/* </div> */}
                      </div>

                      <div className="form-group col-sm-3">
                        {/* <div className="form-group"> */}
                        <label>
                          Select Operator<span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          value={
                            selectedCountry?.countryName === "All"
                              ? "All"
                              : selectedOperator?.operatorName || ""
                          }
                          onChange={handleOperatorChange}
                          required
                          disabled={selectedCountry?.countryName === "All"}
                        >
                          <option value="">Select Operator</option>
                          {userData?.userGroups != 6 && (
                            <option value="All">All</option>
                          )}
                          {userData?.userGroups == 6 ? (
                            <>
                              {selectedCountry?.cpOperatorList?.map(
                                (operator) => (
                                  <option
                                    key={operator.operatorId}
                                    value={operator.operatorName}
                                  >
                                    {operator.operatorName}
                                  </option>
                                )
                              )}
                            </>
                          ) : (
                            <>
                              {selectedCountry?.operatorList?.map(
                                (operator) => (
                                  <option
                                    key={operator.id}
                                    value={operator.operatorName}
                                  >
                                    {operator.operatorName}
                                  </option>
                                )
                              )}
                            </>
                          )}
                        </select>
                        {/* </div> */}
                      </div>
                      <div className="form-group col-sm-3">
                        <label>
                          Select Content Provider
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          value={
                            userData?.userGroups === 4
                              ? userData?.id
                              : // : userData?.userGroups === 6
                                // ? userData?.userId
                                contentPartner
                          }
                          onChange={handleContentPartnerChange}
                          disabled={
                            userData?.userGroups === 4 ||
                            // userData?.userGroups === 6 ||
                            selectedCountry?.countryName === "All" ||
                            selectedOperator?.operatorName === "All"
                          }
                        >
                          <option value="">--Select Content Provider--</option>
                          {userData?.userGroups === 4 ? (
                            <option
                              value={
                                // userData?.userGroups === 4
                                //   ?
                                userData?.id
                                // : userData?.userId
                              }
                            >
                              {userData?.username}
                            </option>
                          ) : userData?.userGroups === 6 ? (
                            <>
                              {selectedOperator?.cpUserAllocations?.map(
                                (item) => (
                                  <option key={item?.id} value={item?.cppId}>
                                    {item?.cpName}
                                  </option>
                                )
                              )}
                            </>
                          ) : (
                            <>
                              <option value="All">All</option>
                              {cpList?.map((item) => (
                                <option key={item?.id} value={item?.id}>
                                  {item?.username}
                                </option>
                              ))}
                            </>
                          )}
                        </select>
                      </div>

                      <div className="form-group col-sm-3">
                        {/* <div className="form-group"> */}
                        <label>
                          Select Service<span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          value={
                            selectedCountry?.countryName === "All"
                              ? "All"
                              : selectedService?.id || ""
                          }
                          onChange={handleServiceChange}
                          disabled={selectedCountry?.countryName === "All"}
                        >
                          <option value="">--Select Service--</option>
                          <option value="All">All</option>
                          {serviceListData.map((item) => (
                            <option key={item?.id} value={item?.id}>
                              {item?.serviceName}
                            </option>
                          ))}
                        </select>
                        {/* </div> */}
                      </div>

                      <div className="form-group col-sm-3">
                        {/* <div className="form-group"> */}
                        <label>
                          Select Service Package
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          value={
                            selectedCountry?.countryName === "All"
                              ? "All"
                              : selectedPackage?.id || ""
                          }
                          onChange={handlePackageChange}
                          disabled={selectedCountry?.countryName === "All"}
                        >
                          <option value="">--Select Package--</option>
                          <option value="All">All</option>
                          {servicePackageListData.map((item) => (
                            <option key={item?.id} value={item?.id}>
                              {item?.productName} - {item?.pricePoint}{" "}
                              {item?.packType}
                            </option>
                          ))}
                        </select>
                        {/* </div> */}
                      </div>
                      <div className="form-group col-sm-3">
                        <label>
                          Start Date<span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={dateRange.startDate}
                          max={
                            dateRange.endDate ||
                            new Date(
                              new Date().setDate(new Date().getDate() - 1)
                            )
                              .toISOString()
                              .split("T")[0]
                          }
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            if (
                              dateRange.endDate &&
                              selectedDate > dateRange.endDate
                            ) {
                              Swal.fire({
                                icon: "error",
                                text: "Start date cannot be greater than end date",
                              });
                              return;
                            }
                            setDateRange((prev) => ({
                              ...prev,
                              startDate: selectedDate,
                            }));
                          }}
                        />
                      </div>

                      <div className="form-group col-sm-3">
                        <label>
                          End Date<span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={dateRange.endDate}
                          min={dateRange.startDate} // Prevent selecting date before start date
                          max={
                            new Date(
                              new Date().setDate(new Date().getDate() - 1)
                            )
                              .toISOString()
                              .split("T")[0]
                          } // Set max date to yesterday
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            if (
                              dateRange.startDate &&
                              selectedDate < dateRange.startDate
                            ) {
                              Swal.fire({
                                icon: "error",
                                text: "End date cannot be less than start date",
                              });
                              return;
                            }
                            setDateRange((prev) => ({
                              ...prev,
                              endDate: selectedDate,
                            }));
                          }}
                          disabled={!dateRange.startDate} // Disable until start date is selected
                        />
                      </div>
                    </div>
                    <div className="form-group d-flex gap-2 justify-content-between res_sub">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={
                          // If country is "All", only check date range
                          selectedCountry?.countryName === "All"
                            ? !dateRange.startDate || !dateRange.endDate
                            : !selectedCountry ||
                              !selectedOperator ||
                              !contentPartner ||
                              !selectedService ||
                              !selectedPackage ||
                              !dateRange.startDate ||
                              !dateRange.endDate
                        }
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
                {/* Add the ViewDND component */}

                {/* Add the table section */}

                {dndList.length > 0 && (
                  <div className="card mt-4 p-3">
                    <div className="dnd-table-container">
                      {/* Add entries selector and refresh button */}
                      <div className="form-group d-flex align-items-center justify-content-between gap-2 records">
                        <div className="d-flex">
                          <span>Show</span>
                          <select
                            className="form-select count_select mx-2"
                            value={pageSize}
                            onChange={(e) => {
                              setPageSize(Number(e.target.value));
                              setCurrentPage(0);
                              handleSubmit(new Event("submit"));
                            }}
                            style={{ width: "auto" }}
                          >
                            {[10, 25, 50, 100].map((size) => (
                              <option key={size} value={size}>
                                {size}
                              </option>
                            ))}
                          </select>
                          <span>entries</span>
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary ref_but"
                            onClick={() => handleSubmit(new Event("submit"))}
                          >
                            Refresh &nbsp;
                            <i className="fas fa-sync ms-auto"></i>
                          </button>
                        </div>
                      </div>

                      {/* Table */}
                      <div id="table">
                        <CustomTable
                          data={dndList}
                          enabledColumns={tableConfig.enabledColumns}
                          actions={tableConfig.actions}
                          onAction={handleTableAction}
                          currentPage={currentPage}
                          pageSize={pageSize}
                          // onPageChange={(page) => setCurrentPage(page)}
                          showPagination={true}
                          totalElements={paginationData.totalElements}
                          totalPages={paginationData.totalPages}
                          renderAction={(row) =>
                            renderActionButtons(row.actions)
                          }
                        />
                      </div>
                      {/* Add pagination info */}
                      <div
                        className="d-flex justify-content-between align-items-center flex-column flex-md-row w-100"
                        id="pagination"
                      >
                        <div className="mr-3 line_pagination px-2 px-md-0">
                          Showing {currentPage * pageSize + 1} to{" "}
                          {Math.min(
                            (currentPage + 1) * pageSize,
                            paginationData.totalElements
                          )}{" "}
                          of {paginationData.totalElements} entries
                        </div>
                        <div className="pages">
                          <PaginationComponent
                            currentPage={currentPage}
                            onPageChange={(page) => {
                              setCurrentPage(page);
                            }}
                            totalPages={paginationData.totalPages}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SubscriberRevenueReport;
